import processJson from "../../data/socialMediaMarketingProcess.json";

export default function Section3() {
  const processData = processJson;

  return (
    <div className="Section3 py-[35px] bg-[#F5F5F5]">
      <div className="section3-container mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] xl:w-[1170px]">
        <h2 className="text-[#da2128] mt-5 mb-3 text-center text-[24px] md:text-[34px] leading-[40px] font-bold">
          How We Do It?
        </h2>

        <div className="flex flex-wrap justify-between gap-x-[30px]">
          {processData.map(({ imgUrl, title, text }, index) => {
            return (
              <div className={`mb-[15px] ${index === 8 ? "w-full" : "md:w-[47.9%] lg:w-[48.4%] xl:w-[48.6%]"}`}>
                <h4 className="text-[13px] md:text-[14px] inline-flex items-center my-[10px] w-full text-[#cd2122] font-open leading-[28px] font-bold">
                  <img src={imgUrl} className="mr-[10px]"></img>
                  
                  {title}
                </h4>
                <p className="text-[#535353] mb-5 font-open">{text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
